import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles<{ color: string | undefined }>()((theme, { color }) => ({
    wrapper: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    fileUpload: {
        fontSize: "40px",
    },
    icon: {
        color: color || theme.palette.emteria.text.primary,
    },
}));
interface Props {
    color?: string;
}
const ArrowFileUp = ({ color }: Props) => {
    const { classes, cx } = useStyles({ color });

    return (
        <div className={classes.wrapper}>
            <div className={classes.fileUpload}>
                <i className={cx("fa-solid fa-file-arrow-up", classes.icon)} />
            </div>
        </div>
    );
};

export default ArrowFileUp;
